<template>
  
  <div class="block-menu">
      <ul>
        <li v-for="(item,idx) in MenuLists" :key="idx"><a :href="item.url">{{item.title}}</a></li>
      </ul>
  </div>
</template>

<script>

export default {
  name: 'MenuBlock',
  data(){
    return {
      MenuLists:[
        {
           title:'暮れの酉占い特集TOP',
           url:'/products/86/',
        },
        {
           title:'占いTV会員ホーム',
           url:'/',
        },
      ],
    }
  },
  
}</script>

<style scoped lang='scss'>
@import "../../../../../../sass/commons/commonVariables.scss";

$tori_navy:#142254;
$uranaitv_black:#32373f;

.block-menu{
  ul{
    padding: 0;
    width: calc(100% - 36px);
    margin: 0 auto 40px;
  }
  li{
    border-bottom:1px solid $tori_navy ;
    padding: 16px;
    position: relative;
    list-style: none;
    &:after{
      content: '';
      position: absolute;
      width: 10px;
      height: 10px;
      border-top: 1px solid $tori_navy;
      border-right: 1px solid $tori_navy;
      transform: rotate(45deg);
      top: 45%;
      right: 17px;
      }
  }
  a{
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    text-decoration: none;
    color: $tori_navy;
    display: block;
    
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/kurenotori/partials/MenuBlock.vue